import {
  setGlobalConfig,
  setSpecificMessage,
  email,
  nonEmpty,
  minLength,
  maxLength,
} from 'valibot';
import '@valibot/i18n/ru';

import { messages } from '../../i18n/messages';
import { AppLocale } from '../../i18n/types';

const langByLocale: Record<AppLocale, string> = {
  ru: 'ru',
  en: 'en',
};

const specificMessages: Record<AppLocale, Readonly<Parameters<typeof setSpecificMessage>[]>> = {
  ru: [
    [email, messages[AppLocale.RU].validation.emailInvalid],
    [nonEmpty, messages[AppLocale.RU].validation.required],
    [maxLength, (params) => `Максимум ${params.requirement} символов, сейчас ${params.received}`],
    [minLength, (params) => `Минимум ${params.requirement} символов, сейчас ${params.received}`],
  ],
  en: [
    [email, messages[AppLocale.EN].validation.emailInvalid],
    [nonEmpty, messages[AppLocale.EN].validation.required],
    [
      maxLength,
      (params) => `Maximum ${params.requirement} characters, currently ${params.received}`,
    ],
    [
      minLength,
      (params) => `Minimum ${params.requirement} characters, currently ${params.received}`,
    ],
  ],
};

const setSchemasLocale = (locale: AppLocale): void => {
  const lang: string = langByLocale[locale];
  setGlobalConfig({ lang });

  for (const specificMessage of specificMessages[locale]) {
    setSpecificMessage(specificMessage[0], specificMessage[1], lang);
  }
};

export { setSchemasLocale };
